/**
 * MenuLabel is the only always visible part of Menu.
 * Clicking it toggles visibility of MenuContent.
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './MenuLabel.module.css';

const MenuLabel = props => {
  const {
      children,
      className = null,
      rootClassName = '',
      isOpen = false,
      isOpenClassName = null,
      onToggleActive = null,
  } = props;
  const [clickedWithMouse, setClickedWithMouse] = useState(false);

  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();
    if (onToggleActive) onToggleActive();
    const nativeEvent = e.nativeEvent;
    const isRealClick = !(nativeEvent.clientX === 0 && nativeEvent.clientY === 0);
    if (isRealClick) {
      setClickedWithMouse(true);
    }
  };

  const onBlur = () => {
    setClickedWithMouse(false);
  };

  const rootClass = rootClassName || css.root;
  const isOpenClass = isOpenClassName || css.isOpen;
  const classes = classNames(rootClass, className, {
    [css.clickedWithMouse]: clickedWithMouse,
    [isOpenClass]: isOpen,
  });

  return (
    <button className={classes} onClick={onClick} onBlur={onBlur}>
      {children}
    </button>
  );
};



const { bool, func, node, string } = PropTypes;

MenuLabel.propTypes = {
  children: node.isRequired,
  className: string,
  isOpenClassName: string,
  isOpen: bool,
  onToggleActive: func,
  rootClassName: string,
};

export default MenuLabel;
